/**
 *  Created by piotr@revisual.io on 15/03/2026
 */

function LoadingState() {
  const rows = [1, 0.6, 0.3];
  return (
    <div className="eew-shimmer-table">
      <div className="eew-shimmer-thead">
        <div className="eew-scol-a">
          <div className="eew-skel eew-skel-h" style={{ width: "55%" }} />
        </div>
        <div className="eew-scol-b">
          <div className="eew-skel eew-skel-h" style={{ width: "70%" }} />
        </div>
        <div className="eew-scol-c">
          <div className="eew-skel eew-skel-h" style={{ width: "60%" }} />
        </div>
        <div className="eew-scol-d">
          <div className="eew-skel eew-skel-h" style={{ width: "80%" }} />
        </div>
      </div>
      {rows.map((opacity, i) => (
        <div key={i} className="eew-shimmer-row" style={{ opacity }}>
          <div className="eew-scol-a">
            <div
              className="eew-skel eew-skel-h"
              style={{ width: `${60 + i * 8}%` }}
            />
            <div className="eew-skel eew-skel-h-sm" style={{ width: "38%" }} />
          </div>
          <div className="eew-scol-b">
            <div className="eew-skel eew-skel-h-sm" style={{ width: "100%" }} />
            <div className="eew-skel eew-skel-h" style={{ width: "50%" }} />
          </div>
          <div className="eew-scol-c">
            <div className="eew-skel eew-skel-h-sm" style={{ width: "100%" }} />
            <div className="eew-skel eew-skel-h" style={{ width: "55%" }} />
          </div>
          <div className="eew-scol-d">
            <div
              className="eew-skel eew-skel-h"
              style={{ width: "60%", borderRadius: 10 }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default LoadingState;
